import { BoundWithLocations, FinnairAirBounds, FinnairBoundGroupWithLocation } from '@fcom/common/interfaces/booking';
import { Cabin, FinnairBoundItem, FinnairCabinClass, OfferList } from '@fcom/dapi/api/models';
import { TzDate } from '@fcom/core/utils';

import { isLongHaulLegAndAy } from './flight.utils';

export const getCabinClassesForAwardBounds = (
  bounds: BoundWithLocations[],
  locations: OfferList['locations']
): FinnairCabinClass[] => {
  return [FinnairCabinClass.ECONOMY, FinnairCabinClass.ECOPREMIUM, FinnairCabinClass.BUSINESS].filter((cabinClass) => {
    return bounds.some((bound) => {
      return isCabinClassFound(bound, cabinClass) && isLongHaulLegAndAy(bound.itinerary, locations);
    });
  });
};

export const getCabinClassesForBounds = (bounds: FinnairAirBounds): FinnairCabinClass[] => {
  return [FinnairCabinClass.ECONOMY, FinnairCabinClass.ECOPREMIUM, FinnairCabinClass.BUSINESS].filter((cabinClass) => {
    return bounds.boundGroups.find((bound: FinnairBoundGroupWithLocation) => {
      return isCabinClassFound(bound, cabinClass) && isLongHaulLegAndAy(bound.details.itinerary, bounds.locations);
    });
  });
};

const isCabinClassFound = (
  bound: BoundWithLocations | FinnairBoundGroupWithLocation,
  cabinClass: FinnairCabinClass | Cabin
) => {
  return bound.fareFamilies?.find((fareInfo) => {
    return fareInfo.fareInformation.find((fareInformation) => {
      return fareInformation.cabinClass === cabinClass;
    });
  });
};

/**
 * Check if flight has lees then 24 hours of stopOver
 * @param bounds
 */
export const hasBound24HourStopOver = (bounds: FinnairBoundItem[]): boolean => {
  let previousBound: FinnairBoundItem | undefined = undefined;

  return bounds.some((currentBound) => {
    if (!previousBound) {
      previousBound = currentBound;
      return false;
    }
    if (has24HourDifference(previousBound.arrival.dateTime, currentBound.departure.dateTime)) {
      return true;
    }

    previousBound = currentBound;
    return false;
  });
};

/**
 * Check if dates has less than 24 hours difference
 *
 * @param arrivalDateTime ISO 8601 format
 * @param departureDateTime ISO 8601 format
 */
const has24HourDifference = (arrivalDateTime: string, departureDateTime: string): boolean => {
  const arrival = new TzDate(arrivalDateTime);
  const departure = new TzDate(departureDateTime);
  const hoursDifference = arrival.hoursTo(departure);

  return hoursDifference > 0 && hoursDifference < 24;
};
